import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    background: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 50%, rgb(255,255,255) 100%)',
    borderTopColor: 'rgba(59,130,246,0.2)'
  }} data-id="element-154">
      <div className="mx-auto max-w-4xl text-center" data-id="element-155">
        {/* Logo */}
        <div className="mb-3 font-black tracking-[2.4px] text-blue-700 text-[18px]" data-id="element-156">
          📖​ BIBLIOTECA PROFESIONAL™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-157">
          El sistema N°1 para estudiantes de Kinesiología que quieren resolver
          la carrera, aprobar sin recursar y recibirse en tiempo.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-158">
          "Porque estudiar Kinesiología no debería costarte todas tus noches y
          fines de semana buscando info dispersa."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-159">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline text-gray-600 hover:text-blue-700 transition-colors" data-id="element-160">
            📧 construyeprogresoo@gmail.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-161">|</span>
          <span className="text-gray-600" data-id="element-162">📲 @BibliotecaProfesional</span>
          <span className="hidden sm:block text-gray-200" data-id="element-163">|</span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline text-gray-600 hover:text-blue-700 transition-colors" data-id="element-164">
            🌐 www.construyeprogreso.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24 bg-blue-700/30" data-id="element-165" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-166">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-167">
            © {new Date().getFullYear()} Bibliotea Profesional™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-168">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}